import React from 'react';
import { Modal } from 'antd';
import { ArrowUp, Check, Sparkles } from 'lucide-react';

const ICONS = { check: Check, submit: ArrowUp, sparkles: Sparkles };

/**
 * Shell shared by the Save & Exit and Submit pop-ups: the purple gradient
 * hero from the original "Ready to submit" modal, then a white body.
 */
const JourneyModal = ({ open, onClose, icon = 'check', title, subtitle, busy = false, children }) => {
    const Icon = ICONS[icon] || Check;

    return (
        <Modal
            open={open}
            onCancel={() => !busy && onClose?.()}
            title={null}
            footer={null}
            closable={false}
            maskClosable={!busy}
            destroyOnClose={true}
            width={560}
            className="[&_.ant-modal-content]:rounded-xl [&_.ant-modal-content]:overflow-hidden [&_.ant-modal-body]:p-0 max-w-[calc(100vw-24px)]"
        >
            <div
                className="px-5 py-6 md:px-8 md:py-7 text-center"
                style={{ background: `linear-gradient(135deg, ${TB.config('color.secondary')} 0%, ${TB.config('color.secondary-darkest')} 100%)` }}
            >
                <div className="mx-auto mb-3 flex h-12 w-12 md:h-14 md:w-14 items-center justify-center rounded-full bg-white/20 text-white">
                    <Icon className="h-6 w-6 md:h-7 md:w-7" strokeWidth={3} />
                </div>
                <h4 className="m-0 text-lg md:text-xl font-bold text-white">{title}</h4>
                {subtitle && <p className="m-0 mt-1 text-sm md:text-base text-white/90">{subtitle}</p>}
            </div>

            <div className="px-5 py-5 md:px-8 md:py-6 flex flex-col items-stretch gap-4 md:gap-5">
                {children}
            </div>
        </Modal>
    );
};

export default JourneyModal;
